// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4fcd562b","198":"2a8542ff","453":"7275d5bf"}[chunkId] + ".chunk.js";
};